import 'core-js/es6';
import 'core-js/es7/reflect';
require('zone.js/dist/zone');
import 'hammerjs';

if (process.env.ENV === 'production') {
    // Production
} else {
    // Development and test
    Error['stackTraceLimit'] = Infinity;
    require('zone.js/dist/long-stack-trace-zone');
}

// fixes a frequent error in IE11 which slows everything down - https://stackoverflow.com/a/51515727
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/polyfills.ts